import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateSpecificationGroupForm from '../../../modules/specificationGroups/components/CreateSpecificationGroupForm';

const CreateSpecificationGroup = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { id } = useParams();
    const title = id ? t('edit_specification_group') : t('create_specification_group');
    dispatch(
        setBreadCrumbsData({
            links: [{ label: title, path: '/specification-groups/create-group' }],
            page_title: title
        })
    );

    return (
        <div>
            <CreateSpecificationGroupForm />
        </div>
    );
};

export default CreateSpecificationGroup;
